
import { IFormFieldItem } from '@/interface/common'
import ValidateService from '@/service/ValidateService'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import SearchMixins from './SearchMixins'

@Component
export default class SearchStringOptionsValue extends Mixins(SearchMixins) {
  @Prop()
  options!: any[]

  private field: IFormFieldItem = ValidateService.genRule({
    prop: 'value',
    label: '值',
    rule: [ValidateService.required({ trigger: 'change', type: 'array' })]
  })
}
